module.exports = __webpack_public_path__ + "static/img/bussinessTv5.7f58530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bussinessTv5.png
// module id = rRUO
// module chunks = 2